import React from "react";
import './Subscribe.css'
const Subscribe = () => {
  return (
    <div className="subscribe flex justify-center">
      <div className="container-size">
        <h6>Submit Newsletters</h6>
        <p>
          Synergistically actualize customer directed paradigms and distinctive
          intellectual
        </p>
        <div className="row flex justify-center mt-6">
          <div className="form-control">
            <label className="input-group">
              <input
                type="text"
                placeholder="Enter your email"
                className="input input-bordered w-full lg:w-80"
              />
              <span className="bg-[#333] text-white font-semibold cursor-pointer">Subscribe</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
